import { useCallback, useState } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import css from './tabListA.module.scss';
import SwiperA from './swiperA';
import KitD from './kitD';
import KitE from './kitE';
import KitF from './kitF';
import KitG from './kitG';
import KitH from './kitH';
import KitI from './kitI';
import ListA from './listA';
import ListB from './listB';
import { useGlobal } from '@/utils/useGlobal';

const TAB_LIST_START_H_NUM = 200;
const TAB_LIST_OVER_NUM = 300;
const elemStart = '.tabListA';
let timerADebounce: NodeJS.Timeout;

export default function TabListA({ callBack, tab }: any) {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const [swiperData, setSwiperData] = useState<any>({
        title1: t('presale.product.tab_listA_title1'),
        title2: t('presale.product.tab_listA_title2'),
        list: [],
    });

    const videoMap = {
        us: ['/video/mm100m/app_rv.mp4', '/video/mm100/app_rv.mp4'],
        cn: ['/video/mm100m/app_rv_cn.mp4', '/video/mm100/app_rv_cn.mp4'],
        de: ['/video/mm100m/app_rv_de.mp4', '/video/mm100/app_rv_de.mp4'],
        fr: ['/video/mm100m/app_rv_fr.mp4', '/video/mm100/app_rv_fr.mp4'],
        it: ['/video/mm100m/app_rv_it.mp4', '/video/mm100/app_rv_it.mp4'],
        es: ['/video/mm100m/app_rv_es.mp4', '/video/mm100/app_rv_es.mp4'],
    };

    const opacityAnimate = useCallback((pClassName, list, startHNum = TAB_LIST_START_H_NUM, overHNum = TAB_LIST_OVER_NUM) => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `${elemStart} ${pClassName}`,
            offset: startHNum, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHNum, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timeline = new TimelineMax();
        list?.forEach((item: any) => {
            const tween = TweenMax.fromTo(`${elemStart} ${item.class}`, Number(`${item.duration || 0.2}`), { opacity: 0 }, { opacity: 1 });
            item.position ? timeline.add(tween, item.position) : timeline.add(tween);
        });
        scene.setTween(timeline);
        AniContainer?.addScene(scene);
    }, []);

    // 异步去设置swiper的数据
    useEffect(() => {
        const doSwiperData = () => {
            clearInterval(timerADebounce);
            timerADebounce = setTimeout(() => {
                const tabHeadDom = document.querySelector('.product-wrapper .kitC') as HTMLElement;
                const tabHeadDomOffsetTop = tabHeadDom?.offsetTop;
                const windowScrollH = document.documentElement.scrollTop;

                if (windowScrollH > tabHeadDomOffsetTop && swiperData?.list.length === 0) {
                    document.removeEventListener('scroll', doSwiperData);
                    setSwiperData({
                        title1: t('presale.product.tab_listA_title1'),
                        title2: t('presale.product.tab_listA_title2'),
                        list: [
                            {
                                i18n: 'classA',
                                src: ['/video/mm100m/classA.webm', '/video/mm100/classA.mp4'],
                            },
                            {
                                i18n: 'classB',
                                src: ['/video/mm100m/classB.webm', '/video/mm100/classB.mp4'],
                            },
                            {
                                i18n: 'classC',
                                src: ['/video/mm100m/classC.webm', '/video/mm100/classC.mp4'],
                            },
                            {
                                i18n: 'trailer',
                                src: ['/video/mm100m/trailer.webm', '/video/mm100/trailer.mp4'],
                            },
                        ],
                    });
                }
            }, 100);
        };
        document.addEventListener('scroll', doSwiperData);
        return () => {
            document.removeEventListener('scroll', doSwiperData);
        };
    }, []);

    // kitD 动画--1
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitD .kit-inter`,
            offset: TAB_LIST_START_H_NUM, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: TAB_LIST_OVER_NUM, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let tweenA1: TweenMax | null = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms1`,
            0.5,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        sceneA1.setTween(tweenA1);

        AniContainer?.addScene(sceneA1);

        return () => {
            sceneA1.destroy(true);
            tweenA1 = null;
        };
    }, []);

    // kitD 动画--2
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitD .kit-box2`,
            offset: TAB_LIST_START_H_NUM, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: TAB_LIST_OVER_NUM * 1.5, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timelineA1: TimelineMax | null = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms-a1`,
            0.4,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA2 = TweenMax.fromTo(
            `${elemStart} .kitD .list-box2`,
            0.8,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA3 = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms-a2`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        timelineA1.add(tweenA1).add(tweenA2).add(tweenA3);
        sceneA1.setTween(timelineA1);

        AniContainer?.addScene(sceneA1);
        return () => {
            sceneA1.destroy(true);
            timelineA1 = null;
        };
    }, []);

    // kitE 动画
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitE .kit-inter-rv`,
            offset: TAB_LIST_START_H_NUM, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: TAB_LIST_OVER_NUM * 2, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timelineA1: TimelineMax | null = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms1`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA2 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms2`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA3 = TweenMax.fromTo(
            `${elemStart} .kitE .rv-box`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA4 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms3`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA5 = TweenMax.fromTo(
            `${elemStart} .kitE .watch-video-btn`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA6 = TweenMax.fromTo(
            `${elemStart} .kitE .more-win-fun`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        timelineA1.add(tweenA1).add(tweenA4).add(tweenA2, 0.2).add(tweenA3, 0.2).add(tweenA5, 0.4).add(tweenA6, 0.4);
        sceneA1.setTween(timelineA1);

        AniContainer?.addScene(sceneA1);

        return () => {
            sceneA1.destroy(true);
            timelineA1 = null;
        };
    }, []);

    useEffect(() => {
        // swiperA 动画
        const swiperA1 = [{ class: '.swiperA .kit-ms1', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA1);
        const swiperA2 = [{ class: '.swiperA .kit-ms2', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA2);

        // kitF 动画
        const kitFList = [{ class: '.kitF .kit-ms1' }];
        opacityAnimate('.kitF .kit-ms1', kitFList);

        //KitG 动画
        const kitGList1 = [{ class: '.kitG .kit-ms1' }];
        opacityAnimate('.kitG .kit-ms1', kitGList1);
        const kitGList2 = [{ class: '.kitG .kit-ms2' }];
        opacityAnimate('.kitG .kit-ms2', kitGList2);
        const kitGList3 = [{ class: '.kitG .kit-ms3' }];
        opacityAnimate('.kitG .kit-ms3', kitGList3);

        // KitH 动画
        const kitHList1 = [{ class: '.kitH .kit-ms1' }];
        opacityAnimate('.kitH .kit-l', kitHList1);
        const kitHList2 = [{ class: '.kitH .kit-ms2' }];
        opacityAnimate('.kitH .kit-ms2', kitHList2);
        const kitHList3 = [{ class: '.kitH .kit-ms3' }];
        opacityAnimate('.kitH .kit-ms3', kitHList3);

        // ListA 动画
        const listAList1 = [{ class: '.listA .kit-ms1' }];
        opacityAnimate('.listA .kit-ms1', listAList1);
        const listAList2 = [{ class: '.listA .kit-ms2' }];
        opacityAnimate('.listA .kit-ms2', listAList2);

        // KitI 动画
        const kitIList1 = [{ class: '.kitI .kit-ms1' }, { class: '.kitI .kit-ms2' }];
        opacityAnimate('.kitI .kit-inter1', kitIList1);
        const kitIList2 = [{ class: '.kitI .kit-inter2' }];
        opacityAnimate('.kitI .kit-inter2', kitIList2);

        // ListB 动画
        const listBList1 = [{ class: '.listB .title' }];
        opacityAnimate('.listB .title', listBList1);
        const listBList2 = [{ class: '.listB .desc' }];
        opacityAnimate('.listB .desc', listBList2);
        const listBList3 = [{ class: '.listB .learn' }];
        opacityAnimate('.listB .learn', listBList3);
        const listBList4 = [{ class: '.listB .kit-r', duration: 3 }];
        opacityAnimate('.listB .kit-r', listBList4, 300);
    }, []);

    return (
        <div className={`${css.tabListA} tabListA`}>
            <SwiperA data={swiperData} tab={tab} />
            <KitD />
            <KitE type="rv" callBack={callBack} />
            <KitF type="rv" />
            <KitG type="rv" />
            <KitH type="rv" />
            <ListA />
            <KitI type="rv" />
            <ListB callBack={callBack} video={videoMap[locale as keyof typeof videoMap] || videoMap.us} />
        </div>
    );
}
